module.exports = __webpack_public_path__ + "img/SpectroPicNegative.a2df3fa6.png";